<!--Central Input and Fieldsets-->
<div class="grid">
  <div class="col-12">
    <div class="col-5"></div>
    <div class="col-7">
      <p-checkbox [binary]="true" [label]="'UPLOAD_COMPONENT.ADD_ADDRESS_PAGE' | translate" [(ngModel)]="addressPage"></p-checkbox>
    </div>
  </div>
  <!-- All Inputs and Buttons-->
  <div class="col-7 inputFields">

    <!--Country-->
    <div class="grid">
      <!--Country Label-->
      <div class="col-5">
        <p>{{ 'ADDRESS_COMPONENT.COUNTRY_LABEL' | translate }}</p>
      </div>

      <!--Country Dropdown-->
      <div class="col-6">
        <p-dropdown [filter]="true" [options]="countryList" [(ngModel)]="selectedCountry"
                    (onChange)="setCountryProperties()" placeholder="{{ 'ADDRESS_COMPONENT.DEFAULT_COUNTRY_LIST_PLACEHOLDER' | translate }}"></p-dropdown>
      </div>

    </div>

    <!--Address Fields-->
    <div *ngFor="let input of addressesLines; let i = index">
      <div class="grid inputFields" *ngIf="input.bDataInput">

        <!--Label-->
        <div class="col-5">
          <p>{{input.sDataLibValue}}</p>
        </div>

        <!--Input field-->
        <div class="col-6">
          <input pDroppable="elem" (onDrop)="getDragDropElem(i)" pInputText type="text"
                 [(ngModel)]="addressesLines[i].sDataValue" (ngModelChange)="formatGlobalAdress()"
                 [ngClass]="{'requiredCombination': !numberOfNonMandatoryFieldIsOk() && !input.bDataMandatory,'criteriaNotMatch': !input.isInputValid()}">
        </div>

        <!--Action -->
        <div class="col-1">
          <i class="fa fa-trash clickable" (click)="clearInputField(i)"
             title="{{ 'ADDRESS_COMPONENT.CLEAR_INPUT_FIELD' | translate }}"></i>
        </div>
      </div>
    </div>

    <!--Space before button-->
    <div class="col-5 center">
      <div *ngIf="currentUser.admin && displayAddressDefinition">
        <button pButton type="button" [icon]="'fa fa-flag-checkered'" [label]="'COMMON.EDIT_LABELS' | translate" class="p-button-warning"
                (click)="triggerLabelDefinition(true)">
        </button>
      </div>
    </div>

    <!--Save and information button-->
    <div class="col-6 center">

      <!--Save Button-->
      <button pButton type="button" [icon]="'fa fa-check'" [label]="'COMMON.VALIDATE' | translate" class="p-button-success"
              [disabled]="!globalFormatAdressIsValid()" (click)="setNewAddress()">
      </button>


      <!--Information button-->
      <a *ngIf="externalDescriptionLink" target="_blank" href="{{externalDescriptionLink}}">
        <button pButton type="button" [icon]="'fa fa-info'" [label]="'ADDRESS_COMPONENT.BUTTON_COUNTRY_CARD' | translate">
        </button>
      </a>

    </div>
  </div>

  <!--Fieldset Part: Draggable items and formatted Address-->
  <div class="col-5 noInPutFields">

    <!--Draggable items-->
    <p-fieldset *ngIf="draggableItems && draggableItems.length>0"
                [legend]="'ADDRESS_COMPONENT.DRAG_DROP_FIELDSET_TITLE' | translate">
      <ul>
        <li *ngFor="let item of draggableItems">
          <button (onDragStart)="setDragDropElem(item)" pDraggable="elem" pButton type="button" [label]="item"
                  class="p-button-secondary"></button>
        </li>
      </ul>

    </p-fieldset>

    <!--formatted Address- -->
    <p-fieldset *ngIf="addressesLines" [legend]="'ADDRESS_COMPONENT.FORMATTED_ADDRESS_FIELDSET_LABEL' | translate">
      <ul>
        <li *ngFor="let formatedLine of formatedAdress">
          <p>{{formatedLine}}</p>
        </li>
      </ul>
    </p-fieldset>

  </div>

</div>

<!--Not respected rules-->
<div class="col-12" *ngIf="addressesLines && !globalFormatAdressIsValid()">
  <p-fieldset [legend]="'ADDRESS_COMPONENT.NOT_RESPECTED_LIST_TITLE' | translate">
    <ul>
      <div *ngFor="let input of addressesLines">
        <li *ngIf="input.bDataMandatory && !input.isInputValid()">{{input.sDataLibValue}}:
          {{getReasonWhyInputIsNotValid(input)}}
        </li>
        <li *ngIf="!input.bDataMandatory && !input.isInputValid()">{{input.sDataLibValue}}:
          {{getReasonWhyInputIsNotValid(input)}}
        </li>
      </div>
      <li *ngIf="!numberOfNonMandatoryFieldIsOk()">{{getReasonWhyCombinationIsNotValid()}}</li>
    </ul>
  </p-fieldset>
</div>

<!--Error message from back-->
<div class="col-12 center error" *ngIf="errorMessage">
  <p> {{errorMessage}}</p>
</div>

<p-dialog *ngIf="displayLabelDefinition" [(visible)]="displayLabelDefinition" [styleClass]="'dataTablesModal'" [appendTo]="'body'"
          [header]="'COMMON.EDIT_LABELS' | translate"
          [draggable]="false"
          [closable]="true"
          [resizable]="false"
          [modal]="true"
          [closeOnEscape]="false">
  <div class="col-12">
    <app-address-labels [addressData]="addressesLines" [country]="propertiesOfSelectedCountry.sIsoID" (showDialog)="triggerLabelDefinition($event)"></app-address-labels>
  </div>
</p-dialog>
